import { Fancybox } from "@fancyapps/ui";
export default function fancybox() {
    Fancybox.bind("[data-fancybox]", {
        Thumbs: false,
        Toolbar: {
            display: {
                right: ["close"],
            },
        },
    });
}